import { gql } from 'apollo-angular'

import { SUBSCRIPTION_WITH_PRICING_FIELDS } from '../../fragments/subscription-with-pricing.fragment'

export const GET_SUBSCRIPTION_AND_PRICING = gql`
  query Subscription($id: Int!) {
    Subscription(select: true, id: $id) {
      ...SubscriptionWithPricingFields
    }
  }
  ${SUBSCRIPTION_WITH_PRICING_FIELDS}
`
